import { lazy, Suspense, useContext, useEffect } from 'react';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';
// import appContext from 'src/Context/AppContext';
import DashboardLayout from 'src/layouts/dashboard';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { authActions } from 'src/redux/userAuth/authSlice';

export const IndexPage = lazy(() => import('src/pages/app'));
export const UserPage = lazy(() => import('src/pages/user'));
export const LogsPage = lazy(() => import('src/pages/logs'));
export const LoginPage = lazy(() => import('src/pages/login'));
export const ProductsPage = lazy(() => import('src/pages/products'));
export const Page404 = lazy(() => import('src/pages/page-not-found'));
// export const Password = lazy(() => import("src/pages/Password"))
export const ForgetPassword = lazy(() => import("src/sections/login/ForgetPassword"))
export const ResetPassword = lazy(() => import("src/sections/login/ResetPassword"))
// import { authActions } from 'src/redux/auth/authSlice';

// ---------------------------------------------------------------------- 
export default function Router1() {

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(authActions?.handleRefresh())
  }, [])

  const { user } = useSelector((state) => state.auth);

  const token = localStorage.getItem("token") || "";



  const routes = useRoutes([
    token ?
      {
        element: (
          <DashboardLayout>
            <Suspense>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        ),
        children: [
          { element: <IndexPage />, index: true },
          { path: 'user', element: <UserPage /> },
          { path: 'logs', element: <LogsPage /> },
        ],
      }
      :
      {
        path: '/',
        element: <LoginPage />, index: true
      },
    { path: 'ForgetPassword', element: <ForgetPassword /> },
    { path: "ResetPassword/:id/:token", element: <ResetPassword /> },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: '404',
      element: <Page404 />,
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },

  ]);

  return routes;
}


// { path: '/', element: user ? <IndexPage /> : <Navigate to="/login" replace /> },